export default 
{
  "login": "DarrenDavy12",
  "id": 42151912,
  "node_id": "MDQ6VXNlcjQyMTUxOTEy",
  "avatar_url": "https://avatars.githubusercontent.com/u/42151912?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/DarrenDavy12",
  "html_url": "https://github.com/DarrenDavy12",
  "followers_url": "https://api.github.com/users/DarrenDavy12/followers",
  "following_url": "https://api.github.com/users/DarrenDavy12/following{/other_user}",
  "gists_url": "https://api.github.com/users/DarrenDavy12/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/DarrenDavy12/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/DarrenDavy12/subscriptions",
  "organizations_url": "https://api.github.com/users/DarrenDavy12/orgs",
  "repos_url": "https://api.github.com/users/DarrenDavy12/repos",
  "events_url": "https://api.github.com/users/DarrenDavy12/events{/privacy}",
  "received_events_url": "https://api.github.com/users/DarrenDavy12/received_events",
  "type": "User",
  "site_admin": false,
  "name": null,
  "company": null,
  "blog": "",
  "location": null,
  "email": null,
  "hireable": null,
  "bio": null,
  "twitter_username": null,
  "public_repos": 16,
  "public_gists": 0,
  "followers": 1,
  "following": 1,
  "created_at": "2018-08-06T17:45:53Z",
  "updated_at": "2022-01-05T14:02:43Z"
}